export default __webpack_public_path__ + "static/media/lk.08a234d8.svg";